import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {action, autorun, observable} from "mobx";

@inject('whiteBoardStore')
@observer
export default class WhiteBoardCursor extends Component {
    @observable clientX;
    @observable clientY;
    @observable show = false;


    @action mouseMoveHandle = (event) => {
        this.clientX = event.clientX;
        this.clientY = event.clientY;
    }

    @action mouseEnterHandle = () => {
        this.show = true;
    }

    @action mouseLeaveHandle = () => {
        this.show = false;
    }

    componentDidMount() {
        autorun(() => {
            if (this.props.container) {
                this.props.container.addEventListener('mousemove', this.mouseMoveHandle);
                this.props.container.addEventListener('mouseenter', this.mouseEnterHandle);
                this.props.container.addEventListener('mouseleave', this.mouseLeaveHandle);
            }

        })
    }


    componentWillUnmount() {
        if (this.props.container) {
            this.props.container.removeEventListener('mousemove', this.mouseMoveHandle);
            this.props.container.removeEventListener('mouseenter', this.mouseMoveHandle);
            this.props.container.removeEventListener('mouseenter', this.mouseMoveHandle);
        }
    }


    render() {
        const {container, cursor, scale = 1, whiteBoardStore} = this.props;
        if (!container || !cursor || !this.show || whiteBoardStore.isMarkupDragging) {
            return null;
        }

        return <div className={'markup-cursor'} style={{top: this.clientY, left: this.clientX, transform: `scale(${scale})`}}>
            <img src={cursor}/>
        </div>
    }
}